import { render, staticRenderFns } from "./HalfTime.vue?vue&type=template&id=0cf1c1dd&scoped=true&"
import script from "./HalfTime.vue?vue&type=script&lang=js&"
export * from "./HalfTime.vue?vue&type=script&lang=js&"
import style0 from "./HalfTime.vue?vue&type=style&index=0&id=0cf1c1dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1c1dd",
  null
  
)

export default component.exports